import React from "react";
import { TextInput } from "../TextInput/TextInput";
import { EmailInputPropsWithFormControl } from "./EmailInput.types";

/** A `TextInput` of type email: email keyboard on mobile, browser autofill. */
export const EmailInput = React.forwardRef<
  HTMLInputElement,
  EmailInputPropsWithFormControl
>((props, ref) => {
  const { type, ...rest } = props;
  return <TextInput ref={ref} type="email" {...rest} />;
});

EmailInput.displayName = "EmailInput";
